import {
	SceneFactProposalSource,
	SceneFactProposalStatus,
} from "@sitescene/types";

/** Small formatters and labels shared by the scene-proposal pages. */

/**
 * The most a camera's facts can hold; the API refuses a longer edit. Mirrors
 * `SCENE_FACTS_MAX_CHARS` in @sitescene/constant, which this app does not
 * depend on; the server is the one that enforces it.
 */
export const FACTS_MAX_CHARS = 600;

export const SOURCE_LABELS: Record<SceneFactProposalSource, string> = {
	[SceneFactProposalSource.CustomerEdit]: "Customer edit",
	[SceneFactProposalSource.Revert]: "Revert",
	[SceneFactProposalSource.Reviewer]: "Reviewer",
};

export const STATUS_LABELS: Record<SceneFactProposalStatus, string> = {
	[SceneFactProposalStatus.Applied]: "Applied",
	[SceneFactProposalStatus.Drafting]: "Drafting",
	[SceneFactProposalStatus.Failed]: "Failed",
	[SceneFactProposalStatus.NoChange]: "No change",
	[SceneFactProposalStatus.Pending]: "Pending",
	[SceneFactProposalStatus.Rejected]: "Rejected",
	[SceneFactProposalStatus.Reverted]: "Reverted",
	[SceneFactProposalStatus.Superseded]: "Superseded",
};

/**
 * How long ago, coarsely — the queue is read for what is waiting, not for
 * exact times (those are in the row's tooltip). `now` is passed in so a
 * render stays pure.
 */
export const formatAge = (
	value: Date | string | undefined,
	now: number,
): string => {
	if (!value) return "—";
	const minutes = Math.floor((now - new Date(value).getTime()) / 60_000);
	if (minutes < 1) return "just now";
	if (minutes < 60) return `${minutes} min ago`;
	const hours = Math.floor(minutes / 60);
	if (hours < 48) return `${hours} h ago`;
	return `${Math.floor(hours / 24)} d ago`;
};
